import { Tabs } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import LeaveRequestView from 'components/common/view/leave_request_view';
import RequestHistory from 'components/common/view/request_history';
import Success from 'components/common/view/success';
import useAuth from 'hooks/useAuth';
import useNotice from 'hooks/useNotice';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { api } from 'utils/apiRoutes';
import { GET, PUT } from '../../utils';
import NESTEDROUTE from 'utils/router';
import { Loading } from 'components';


const MyRequestDetail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { success, error } = useNotice();
  const { data } = useQuery('query-request-by-id', fetchById);
  const onChange = (key: string) => {
    // console.log(key);
  };
  const { user } = useAuth();
  // console.log(data);

  const location = useLocation();
  const cancelledRequest = (status: string) => {
    const absenceRequestId = location.state.id;
    // console.log(absenceRequestId);
    setLoading(true);

    if (user?.role === 'admin') {

      const url =
        '/api/absence_request/my_managed/' + absenceRequestId + '/approval/';
      PUT(url, { status: status })
        .then((res) => {
          setLoading(false);
          // success('Request cancelled', '/my_request');
          navigate(NESTEDROUTE.change_request, {
            state: {
              data: data?.data,
              status: status
            },
          });

        })
        .catch((err) => {
          error('Request was cancelled');

        });
    } else {

      const url =
        '/api/absence_request/my_request/' + absenceRequestId + '/cancel/';
      PUT(url, { status: status })
        .then((res) => {
          setLoading(false);
          navigate(NESTEDROUTE.change_request, {
            state: {
              data: data?.data,
              status: status
            },
          });
        })
        .catch((err) => {
          error('Request was cancelled');

        });

    }
  };

  function fetchById() {
    const url = `${api.absenceRequestById}/${location.state.id}/`;
    return GET(url);
  }
  if (loading) return <Loading />;
  return (
    <div className={'leave_request'}>

      <GeneralHeader
        status={data && (data as any)?.data?.status}
        icon="/icons/request_app.svg"
        pageTitle={data && (data as any)?.data?.absence_type?.name}
        child={
          <LeaveRequestView data={data?.data} cancelledRequest={cancelledRequest} />
        }
      />

    </div>
  );
};

export default MyRequestDetail;
